export default __webpack_public_path__ + "static/media/light_03.f5f0d5f8.svg";